import PropTypes from 'prop-types';
import React from 'react';

import CartLineItem from 'containers/CartLineItemContainer';

import Placeholder from './Placeholder';

const CartItem = ({ item, isLoading }) => {
  return isLoading ? <Placeholder key="CartItem__placeholder" /> : <CartLineItem id={item.id} />;
};

CartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
  isLoading: PropTypes.bool,
};

CartItem.defaultProps = {
  item: null,
  isLoading: false,
};

export default CartItem;
